module.exports = __webpack_public_path__ + "static/img/ico_third_place.19ae45b5.png";